require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-laura-mirabal-selected-2025-indiana-latino-leadership-circle.json") })
        }
      }, "path---articles-laura-mirabal-selected-2025-indiana-latino-leadership-circle");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-laura-mirabal-selected-2025-indiana-latino-leadership-circle!./.cache/json/articles-laura-mirabal-selected-2025-indiana-latino-leadership-circle.json
// module id = 1709
// module chunks = 231608221292675